"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANADA_STRATEGIST_TEMPLATES = exports.CANADA_STRATEGIST_TEMPLATES_MD = void 0;
exports.CANADA_STRATEGIST_TEMPLATES_MD = {
    'Year Start Meeting (YSM)': `* Three Key Goals for the Year\n
* Timeline for the Year\n
* Academic Update\n
* Extracurricular Update\n
* Standardized Testing Update`,
    'Initial Strategy Meeting (ISM)': `* Introductions\n
* Strategist vs. SSM Role\n
* Academic Strengths & Weaknesses\n
* ECs and Personal Interests\n
* Initial Majors, Careers, Schools Discussion\n
* The Application Process\n
* Preliminary Hook Statement Activity\n
* Resources & Recommendations\n
* Next steps and task setting`,
    'Pathfinder Meeting': `* Introducing Pathfinder\n
* What Admissions Officers Look For\n
* Review Pathfinder and mark off achieved goals\n
* Establish 3-5 new goals\n
* Establish expectations around Pathfinder use during strategy\n
* Outline short-term (now to 3 months), mid-term (3-6 months), and long-term (6+ months) goals\n
* Review common/expected deadlines (eg. key US deadlines for schools of interest)\n
* Review and send the respective NAY or AY timelines\n
* Other Check-in Items`,
    'NAY: Meeting': `#### Check-in\n
* Academics\n
* Extracurriculars\n
* Leadership project\n
* Major/Career Goals\n
* Hook statement\n
* School research\n
* Summer plans\n
* Testing\n
* Writing\n
#### Meeting Focus Area: Insert topic here`,
    'NAY: Mid Review Meeting': `#### Check-in\n
* Academics\n
* Extracurriculars\n
* Leadership project\n
* Major/Career Goals\n
* Hook statement\n
* School research\n
* Summer plans\n
* Testing\n
* Writing\n
#### First Half of the Year Reflection\n
* Candidacy Assesment\n
* Progress on YSM Goals\n
#### Meeting Focus Area: Insert topic here`,
    'AY: Timeline Alignment': `#### App Year Timeline Alignment\n
* Student Handbook\n
* Who's Who\n
* App Year Timeline\n
* Current Application Assessment\n
* Writing 101\n
* Questions`,
    'AY: Writing Alignment': `#### Writing Requirements for College Apps\n
* Why Essays Are Important\n
* Essay Types\n
* Deadline Review\n
* Model Essay Examples\n
#### Writing 101 Feedback\n
* Feedback, Next Steps, and Q&A`,
    'AY: Application Portals': `Application Portals\n
* Answering Common App/Portal Questions\n
#### Progress Check-up\n
* Testing\n
* Essay Progress\n
* School Research`,
    'AY: School List Confirmation': `#### School List Confirmation and Submission Requirements\n
* Confirmed School List\n
* Financial Aid Application Check\n
* Review of Deadlines, Workload, and Additional Submissions\n
* Recommender, Counselor, and School Profile Confirmation`,
    'AY: Interview Prep': `* Pre-Interview Strategy Guidance and Logistical Information\n
* Interview Tutoring and Utilisation Timeline\n
* Other Preparation`,
    'AY: Submission Meeting': `* Application Portal Review and Proof-Reading\n
* Essay Final Formatting\n
* Submission Timeline`,
    'AY: Offer Review': `* Discussion of all Admission Outcomes\n
* Final Choices\n
* Other Crimson Opportunities'`,
    'AY: Final Meeting Before Contract End': `* Final Questions and Guidance Needed\n
* Other Crimson Opportunities\n
* Good Luck and Stay in Touch!`,
    'AY: Other Meeting': '* N/A',
    Other: '* N/A',
};
exports.CANADA_STRATEGIST_TEMPLATES = {
    'Initial Strategy Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introductions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Strategist vs. SSM Role',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Academic Strengths & Weaknesses',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'ECs and Personal Interests',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Initial Majors, Careers, Schools Discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'The Application Process',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Preliminary Hook Statement Activity',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Resources & Recommendations',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 9,
            type: 'p',
            children: [
                {
                    text: 'Next steps and task setting',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Roadmap Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Review Roadmap and Ensure Student Knows How it Works',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Establish 3-5 Immediate New Goals to Add to the Roadamap',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Establish Expectations of How the Roadmap and Student Centre Will Be Used Throughout Strategy',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Outline short-term (now to 3 months), mid-term (3-6 months), and long-term (6+ months) goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Review common/expected deadlines (eg. key US deadlines for schools of interest)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Review and send the respective NAY or AY timelines',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Other Check-in Items',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Year Start Meeting (YSM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Three Key Goals for the Year',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Timeline for the Year',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Academic Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Extracurricular Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Standardized Testing Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Mid Review Meeting (MRM)': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Check-in',
                },
            ],
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Academics',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Extracurriculars',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Leadership project',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Major/Career Goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Hook statement',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'School research',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Summer plans',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Testing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 9,
            type: 'p',
            children: [
                {
                    text: 'Writing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'First Half of the Year Reflection',
                },
            ],
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Candidacy Assesment',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Progress on YSM Goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Meeting Focus Area: Insert topic here',
                },
            ],
        },
    ],
    'Reengagement Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Exploration Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Progress on Certification',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Lesson Plan: [insert name of Lesson Plan]',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Check-ins',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Solidification Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Progress on Certification',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Lesson Plan: [insert name of Lesson Plan]',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Check-ins',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Intensification Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Progress on Certification',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Lesson Plan: [insert name of Lesson Plan]',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Check-ins',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Timeline Alignment': [
        {
            type: 'h4',
            children: [
                {
                    text: 'App Year Timeline Alignment',
                },
            ],
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Student Handbook',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: "Who's Who",
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'App Year Timeline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Current Application Assessment',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Writing 101',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Questions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Writing Alignment': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Writing Requirements for College Apps',
                },
            ],
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Why Essays Are Important',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Essay Types',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Deadline Review',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Model Essay Examples',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Writing 101 Feedback',
                },
            ],
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Feedback, Next Steps, and Q&A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Application Portals': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Application Portals',
                },
            ],
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Answering Common App/Portal Questions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Progress Check-up',
                },
            ],
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Testing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Essay Progress',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'School Research',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: School List Confirmation': [
        {
            type: 'h4',
            children: [
                {
                    text: 'School List Confirmation and Submission Requirements',
                },
            ],
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Confirmed School List',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Financial Aid Application Check',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Review of Deadlines, Workload, and Additional Submissions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Recommender, Counselor, and School Profile Confirmation',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Interview Prep': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Pre-Interview Strategy Guidance and Logistical Information',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Interview Tutoring and Utilisation Timeline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Preparation',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Submission Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Application Portal Review and Proof-Reading',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Essay Final Formatting',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Submission Timeline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Offer Review': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Discussion of all Admission Outcomes',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Final Choices',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Crimson Opportunities',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Final Meeting Before Contract End': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Final Questions and Guidance Needed',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Other Crimson Opportunities',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Good Luck and Stay in Touch!',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Other Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    Other: [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Meeting': [
        {
            type: 'h4',
            children: [
                {
                    text: 'Check-in',
                },
            ],
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Academics',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Extracurriculars',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Leadership project',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Major/Career Goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Hook statement',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'School research',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Summer plans',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Testing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 9,
            type: 'p',
            children: [
                {
                    text: 'Writing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            type: 'h4',
            children: [
                {
                    text: 'Meeting Focus Area: Insert topic here',
                },
            ],
        },
    ],
};
//# sourceMappingURL=canada-strategist-v2.js.map